"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.root = void 0;

var _util = require("../../../util");

const root = ({
  cssProps,
  theme
}) => {
  const {
    interactive = false,
    underline = true,
    maxWidth
  } = cssProps;
  return {
    background: (0, _util.color)(theme, 'background.default'),
    boxShadow: underline ? (0, _util.boxShadow)(theme, [0, -1, 0, 0, 'ui1', true]) : undefined,
    cursor: interactive ? 'pointer' : 'default',
    padding: (0, _util.spacing)(theme, ['small', 'xsmall']),
    transition: 'background 0.2s ease',
    ...(maxWidth && {
      maxWidth
    }),
    ':active': interactive ? {
      background: (0, _util.color)(theme, 'interactive.ui.active'),
      borderRadius: '4px'
    } : undefined,
    ':hover': interactive ? {
      background: (0, _util.color)(theme, 'interactive.ui.hover'),
      borderRadius: '4px'
    } : undefined
  };
};

exports.root = root;
//# sourceMappingURL=ListItem.style.js.map